const TYPE = 0;
const STATION = 0;
const ADAIRED = 1;
const VISITS = 2;
const VISITAD = 3;
const STATION_ID = 4;
const WEB_ANATYLICS = 1;
const CHUNK_ROW = 10;
export default {
    TYPE,
    STATION,
    ADAIRED,
    VISITS,
    STATION_ID,
    VISITAD,
    WEB_ANATYLICS,
    CHUNK_ROW
}

export const ADSICON_TOOLTIP_TEXT = `Recommended 50+ ads for statistical relevance`;

